export function toHHMMSS(seconds: number) {
  const hour = Math.floor(seconds / 3600);
  const minute = Math.floor((seconds % 3600) / 60);
  const second = Math.round(seconds % 60);

  return [
    hour.toString().padStart(2, '0'),
    minute.toString().padStart(2, '0'),
    second.toString().padStart(2, '0'),
  ].join(':');
}
